import { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

import { useActions, useWorkspace } from '@mssgme/hooks';
import { resolvePathname } from '@mssgme/helpers';

export default function useQuickReplyEdit(replyId) {
    const history = useHistory();
    const { url } = useRouteMatch();
    const { api } = useActions();
    const workspace = useWorkspace();
    const [redirectTo, setRedirectTo] = useState();

    useEffect(() => {
        if (redirectTo) {
            history.push(redirectTo);
        }
    }, [redirectTo]);

    const onClose = () => setRedirectTo(resolvePathname(url, '..'));

    let data;
    let onSubmit;
    let onRemove;

    if (replyId) {
        data = workspace.replies.find((reply) => reply._id === replyId);
        onSubmit = (payload) => api.replies.update({ replyId, payload });
        onRemove = () => api.replies.delete({ replyId });
    } else {
        onSubmit = (payload) => api.replies.create({ payload });
    }

    return {
        data,
        onSubmit,
        onRemove,
        onClose,
    };
}
